import styled, { css } from 'styled-components'

export const Subtitle = styled.div`
  color: #757575;
  font-size: 14px;
  font-weight: 700;
  padding-bottom: 4px;
  margin-top: 24px;
`

interface IOptionProps {
  active: boolean
}

export const Option = styled.div<IOptionProps>`
  margin-top: 16px;
  cursor: pointer;
  &:hover {
    .ant-radio-inner {
      border-color: #9ecffa !important;
    }
  }
  label {
    position: absolute;
  }
  .ant-radio-inner {
    border: solid 2px #dcdcdc;
    height: 19px;
    width: 19px;
    &::after {
      top: 2.5px;
      left: 2.5px;
      width: 10px;
      height: 10px;
      background-color: #0085ff;
    }
  }
  ${(props) =>
    props.active &&
    css`
      cursor: default !important;
      .ant-radio-inner {
        border-color: #0085ff !important;
        background-color: #e7f3fe;
      }
      .ant-radio-input {
        cursor: default !important;
      }
    `}
`

export const OptionTitle = styled.div`
  color: #363636;
  font-weight: 500;
  font-size: 14px;
  padding-left: 26px;
`

export const OptionDescription = styled.div`
  color: #757575;
  font-size: 14px;
  padding-left: 26px;
  margin-top: 4px;
`
